// src/components/Footer.js
import React from "react";
import { Box, Typography, Stack, Grid, Link, Divider, Container } from "@mui/material";
import globalLink from "../Assets/giiconnect.png"


export default function Footer() {
  return (

    <Box
      sx={{
        bgcolor: "background.paper",
        borderTop: "1px solid rgba(2, 8, 23, 0.06)",
        py: 8,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} sx={{ mb: 6 }}>
          <Grid item xs={12} sm={6} md={3}>
            {/* <Typography fontWeight="700" sx={{ mb: 2, color: "text.primary" }}>
                    giiconnect
                  </Typography> */}
            {/* <Typography
                    fontWeight="700"
                    sx={{
                      fontSize: "16px",
                      background: "linear-gradient(135deg, #0A2E8A 0%, #10682A 100%)",
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      color: "transparent",
                    }}
                  >
                    giiconnect
                  </Typography> */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                ml: 1,
              }}
            >
              <img
                src={globalLink}
                alt="GiiConnect Logo"
                style={{
                  margin: "10px",
                  width: "170px",
                  height: "75px",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Connecting People. Building Capability. Bridging The Digital Divide.
            </Typography>
          </Grid>
          {[
            {
              title: "Product",
              links: ["Features", "Pricing", "Community"],
            },
            {
              title: "Company",
              links: ["About", "Blog", "Careers"],
            },
            {
              title: "Legal",
              links: ["Privacy", "Terms", "Contact"],
            },
          ].map((col, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Typography fontWeight="700" sx={{ mb: 2, color: "text.primary" }}>
                {col.title}
              </Typography>
              <Stack spacing={1}>
                {col.links.map((link, j) => (
                  <Typography
                    key={j}
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      cursor: "pointer",
                      "&:hover": { color: "primary.main" },
                    }}
                  >
                    {link}
                  </Typography>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems="center" spacing={2}>
          <Typography variant="body2" sx={{ color: "text.secondary", textAlign: { xs: "center", md: "left" } }}>
            © 2026 giiconnect. All rights reserved.
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <Typography sx={{ color: "#979797", fontSize: 13 }}>
              Made by giiconnect Team
            </Typography>
          </Box>
          {/* <Stack direction="row" spacing={3}>
            {["Twitter", "LinkedIn", "Instagram"].map((social) => (
              <Typography
                key={social}
                variant="body2"
                sx={{
                  color: "text.secondary",
                  cursor: "pointer",
                  fontWeight: 600,
                  "&:hover": { color: "primary.main" },
                }}
              >
                {social}
              </Typography>
            ))}
          </Stack> */}
          <Stack direction="row" spacing={3}>
            {[
              { name: "X", url: "https://x.com/giiconnect" },
              { name: "LinkedIn", url: "https://www.linkedin.com/company/giiconnect/" },
              { name: "Instagram", url: "https://www.instagram.com/giiconnect/" },
            ].map((social) => (
              <Link
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                underline="none"
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    cursor: "pointer",
                    fontWeight: 600,
                    "&:hover": { color: "primary.main" },
                  }}
                >
                  {social.name}
                </Typography>
              </Link>
            ))}
          </Stack>
        </Stack>
      </Container>
      <Divider sx={{ my: 3 }} />

      {/* Bottom Row */}


    </Box>
  );
}
